import { render, staticRenderFns } from "./custom-copy-value.vue?vue&type=template&id=4841aa78&"
import script from "./custom-copy-value.vue?vue&type=script&lang=js&"
export * from "./custom-copy-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports